import React from "react";
import carsImage from '../../images/voitures.JPG';
import CategoryPage from '../CategoryPage';

function VoituresPage() {
    const details = [
        "Ferrari 250 GTO – L'une des voitures de collection les plus précieuses et emblématiques au monde.",
        "Porsche 911 Carrera RS 2.7 – Une icône des années 70, prisée pour son design et sa performance.",
        "Jaguar E-Type – Souvent qualifiée de 'plus belle voiture jamais construite', un classique intemporel.",
        "Ford Mustang Shelby GT500 – Un muscle car américain légendaire, recherché pour son style et sa puissance.",
        "Mercedes-Benz 300 SL 'Gullwing' – Réputée pour ses portes papillon et son innovation technologique.",
        "Aston Martin DB5 – Rendue célèbre par James Bond, une voiture de luxe et d’élégance.",
        "Chevrolet Corvette C1 – Le modèle qui a marqué l’histoire des voitures sportives américaines.",
        "Lamborghini Miura – Considérée comme la première supercar moderne, un véritable chef-d'œuvre italien.",
    ];

    return (
        <CategoryPage
            title="Voitures de Collection"
            image={carsImage}
            description="Vous possédez des voitures anciennes ou de collection à vendre ? Qu'il s'agisse de modèles classiques, sportifs ou rares, chaque véhicule a une histoire et une valeur uniques. Contactez-nous pour une estimation personnalisée et une expertise professionnelle."
            details={details}
        />
    );
}

export default VoituresPage;
